export default function SettingsIcon() {
  return (
    <svg width="24" height="25" viewBox="0 0 24 25" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path
        d="M12 15.5C13.6569 15.5 15 14.1569 15 12.5C15 10.8431 13.6569 9.5 12 9.5C10.3431 9.5 9 10.8431 9 12.5C9 14.1569 10.3431 15.5 12 15.5Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M2 13.3814V11.6214C2 10.5814 2.85 9.7214 3.9 9.7214C5.71 9.7214 6.45 8.4414 5.54 6.8714C5.02 5.9714 5.33 4.8014 6.24 4.2814L7.97 3.2914C8.76 2.8214 9.78 3.1014 10.25 3.8914L10.36 4.0814C11.26 5.6514 12.74 5.6514 13.65 4.0814L13.76 3.8914C14.23 3.1014 15.25 2.8214 16.04 3.2914L17.77 4.2814C18.68 4.8014 18.99 5.9714 18.47 6.8714C17.56 8.4414 18.3 9.7214 20.11 9.7214C21.15 9.7214 22.01 10.5714 22.01 11.6214V13.3814C22.01 14.4214 21.16 15.2814 20.11 15.2814C18.3 15.2814 17.56 16.5614 18.47 18.1314C18.99 19.0414 18.68 20.2014 17.77 20.7214L16.04 21.7114C15.25 22.1814 14.23 21.9014 13.76 21.1114L13.65 20.9214C12.75 19.3514 11.27 19.3514 10.36 20.9214L10.25 21.1114C9.78 21.9014 8.76 22.1814 7.97 21.7114L6.24 20.7214C5.33 20.2014 5.02 19.0314 5.54 18.1314C6.45 16.5614 5.71 15.2814 3.9 15.2814C2.85 15.2814 2 14.4214 2 13.3814Z"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeMiterlimit="10"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );
}
